import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet-async'
import Projects from '../components/Projects'

export default function ProjectsPage() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <Helmet>
        <title>Projects | Ionic Errrrs Code</title>
        <meta name="description" content="Browse all projects built by Ionic Errrrs Code — web apps, mobile apps, and SaaS products crafted with modern technologies." />
        <link rel="canonical" href="https://ionicerrrrscode.com/projects" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Ionic Errrrs Code" />
        <meta property="og:title" content="Projects | Ionic Errrrs Code" />
        <meta property="og:description" content="Browse all projects built by Ionic Errrrs Code — web apps, mobile apps, and SaaS products crafted with modern technologies." />
        <meta property="og:url" content="https://ionicerrrrscode.com/projects" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Projects | Ionic Errrrs Code" />
        <meta name="twitter:description" content="Browse all projects built by Ionic Errrrs Code — web apps, mobile apps, and SaaS products crafted with modern technologies." />
      </Helmet>
      <Projects />
    </motion.div>
  )
}
